export default "__VITE_ASSET__BoGA64Dw__"